import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";
import config from "../../config/api";

const BackendURL = config.backendUrl;

export const remindManager = createAsyncThunk(
  "manager/remindManager",
  async (projectId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.post(
        `${BackendURL}/projectaction/remind-manager`,
        { projectId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to send reminder email.";
      return rejectWithValue(message);
    }
  }
);

const remindManagerSlice = createSlice({
  name: "remindManager",
  initialState: {
    loading: false,
    success: false,
    error: null,
    sentTo: [],
    message: "",
  },
  reducers: {
    resetReminderState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.sentTo = [];
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(remindManager.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(remindManager.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.sentTo = action.payload.sentTo || [];
      })
      .addCase(remindManager.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetReminderState } = remindManagerSlice.actions;
export default remindManagerSlice.reducer;
